// src/components/common/vibe/ReactionBar.js
import React from 'react';

const ReactionBar = ({ reactions, onReactionClick, theme }) => {
    return (
        <div className={`absolute bottom-full left-0 mb-2 p-2 rounded-lg shadow-lg border flex gap-1 z-10 animate-fade-in ${
            theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
        }`}>
            {reactions.map((reaction) => (
                <button
                    key={reaction.type}
                    onClick={() => onReactionClick(reaction.type)}
                    className={`p-2 rounded-lg transition-transform hover:scale-125 ${
                        theme === 'dark' ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                    }`}
                    title={reaction.label}
                >
                    <span className="text-2xl">{reaction.emoji}</span>
                </button>
            ))}
        </div>
    );
};

export default ReactionBar;
